import * as bitcoin from "bitcoinjs-lib";
import { BIP32Factory } from "bip32";
import * as ecc from "tiny-secp256k1";

import {
  generateMnemonic,
  mnemonicToSeedSync,
  validateMnemonic,
  PREFIXES,
} from "electrum-mnemonic";


if (typeof ecc.__initializeContext === "function") {
  ecc.__initializeContext();
}


const bip32 = BIP32Factory(ecc);

const NETWORK = bitcoin.networks.bitcoin;

const PURPOSE = 0;



export function normalizeSeed(seed) {
  return String(seed || "")
    .trim()
    .replace(/\s+/g, " ");
}



export function isValidElectrumSeed(seed) {

  const clean = normalizeSeed(seed);

  if (!clean) {
    return false;
  }


  try {

    return validateMnemonic(
      clean,
      PREFIXES.segwit
    );

  } catch {

    return false;

  }
}



export function masterFromElectrumSeed(seed) {

  const clean = normalizeSeed(seed);


  if (!isValidElectrumSeed(clean)) {

    throw new Error(
      "Неверная Electrum seed-фраза"
    );

  }


  const seedBytes =
    mnemonicToSeedSync(
      clean,
      {
        prefix: PREFIXES.segwit
      }
    );


  return bip32.fromSeed(
    seedBytes,
    NETWORK
  );
}



export function deriveWalletKey(
  seed,
  branch = 0,
  index = 0
) {

  const master =
    masterFromElectrumSeed(seed);


  return master
    .deriveHardened(PURPOSE)
    .derive(Number(branch))
    .derive(Number(index));
}



export function getPrivateKey(
  seed,
  branch = 0,
  index = 0
) {

  const node =
    deriveWalletKey(
      seed,
      branch,
      index
    );


  if (!node.privateKey) {

    throw new Error(
      "Нет приватного ключа"
    );

  }


  return node.privateKey;
}



export function signPsbt(
  psbtBase64,
  seed,
  inputPaths
) {


  if (!psbtBase64) {

    throw new Error(
      "PSBT отсутствует"
    );

  }


  if (
    !Array.isArray(inputPaths) ||
    inputPaths.length === 0
  ) {

    throw new Error(
      "Нет входов для подписи"
    );

  }



  const cleanSeed =
    normalizeSeed(seed);



  if (!isValidElectrumSeed(cleanSeed)) {

    throw new Error(
      "Неверная Electrum seed-фраза"
    );

  }



  const psbt =
    bitcoin.Psbt.fromBase64(
      psbtBase64,
      {
        network: NETWORK
      }
    );



  const master =
    masterFromElectrumSeed(
      cleanSeed
    );



  /*
   * ПОДПИСЬ
   */

  for (const item of inputPaths) {


    const inputIndex =
      Number(item.inputIndex);


    const child =
      master
        .deriveHardened(PURPOSE)
        .derive(Number(item.branch))
        .derive(Number(item.index));



    if (!child.privateKey) {

      throw new Error(
        "Нет приватного ключа"
      );

    }



    psbt.signInput(
      inputIndex,
      child
    );

  }




  /*
   * ПРОВЕРКА ПОДПИСИ
   */

  for (const item of inputPaths) {


    const inputIndex =
      Number(item.inputIndex);



    const ok =
      psbt.validateSignaturesOfInput(
        inputIndex,
        (
          pubkey,
          hash,
          signature
        ) => {

          return ecc.verify(
            hash,
            pubkey,
            signature
          );

        }
      );



    if (!ok) {

      throw new Error(
        `Ошибка проверки подписи input ${inputIndex}`
      );

    }

  }



  psbt.finalizeAllInputs();



  const tx =
    psbt.extractTransaction();



  return {

    rawtx:
      tx.toHex(),

    txid:
      tx.getId()

  };

}





/*
 * ЛОКАЛЬНЫЙ ТЕСТ
 */

export function runLocalSigningSelfTest() {


  const testSeed =
    generateMnemonic({
      prefix:
        PREFIXES.segwit
    });



  if (!isValidElectrumSeed(testSeed)) {

    throw new Error(
      "Seed теста невалидный"
    );

  }



  const master =
    masterFromElectrumSeed(
      testSeed
    );



  const child =
    master
      .deriveHardened(PURPOSE)
      .derive(0)
      .derive(0);



  const payment =
    bitcoin.payments.p2wpkh({

      pubkey:
        child.publicKey,

      network:
        NETWORK

    });



  const psbt =
    new bitcoin.Psbt({
      network: NETWORK
    });



  psbt.addInput({

    hash:
      Buffer.alloc(
        32,
        1
      ),

    index:
      0,


    witnessUtxo: {

      script:
        Buffer.from(
          payment.output
        ),

      value:
        BigInt(100000)

    }

  });



  const destination =
    master
      .deriveHardened(PURPOSE)
      .derive(0)
      .derive(1);



  const dest =
    bitcoin.payments.p2wpkh({

      pubkey:
        destination.publicKey,

      network:
        NETWORK

    });



  psbt.addOutput({

    script:
      Buffer.from(
        dest.output
      ),

    value:
      BigInt(90000)

  });


const result = signPsbt(

  psbt.toBase64(),

  testSeed,

  [
    {
      inputIndex: 0,
      branch: 0,
      index: 0
    }
  ]

);


return {
  ok: true,

  address: payment.address,

  destination: dest.address,

  txid: result.txid,

  rawtxLength: result.rawtx.length
};

}



export function clearSecret(){

  return null;

}